/**
 * 粒子发射器
 */
let particleArr = [];
const MAX = 100; //最大粒子数量，超出清空
const CNT = 3;
class CircleElem {
    constructor(centerX, centerY, pen) {
        this.transparency = Math.random()
        this.radius = (pen.PRadius || 5) * Math.random() + 1
        this.color = `rgba(${255 * Math.random()},${255 * Math.random()},${255 * Math.random()},${this.transparency})`
        this.v = 5 * Math.random() + 1
        this.angle = 360 * Math.random()
        this.x = centerX
        this.y = centerY
    }
    draw(ctx) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI)
        ctx.closePath();
        // ctx.fillStyle = this.color;
        ctx.fill();
        ctx.restore();
    }
}

let loaded = false
function createCircle(pen) {
    for (let i = 0; i < CNT; i++) {
        let circle = new CircleElem(pen.calculative.worldRect.center.x, pen.calculative.worldRect.center.y, pen)
        particleArr.push(circle)
    }
}
/**
 * 
 * @param {CanvasRenderingContext2D} ctx 
 * @param {Object} pen 
 */


let stop = null;
export function particle(ctx, pen) {

    let config = {
        PX: pen.PX,
        PY: pen.PY,
        distance: pen.distance || (pen.calculative.worldRect.width-pen.calculative.worldRect.x)/2,
        PRadius: pen.PRadius || 5,
        PEnable: pen.PEnable ?? true
    }

    function drawCircle() {
        ctx.clearRect(pen.calculative.worldRect.x, pen.calculative.worldRect.y, pen.calculative.worldRect.width, pen.calculative.worldRect.height)
        for (let [index, circle] of particleArr.entries()) {
            circle.y += circle.v * Math.sin(circle.angle);
            circle.x += circle.v * Math.cos(circle.angle);
            circle.transparency -= 0.4
            circle.v += .5
            circle.draw(ctx)
            if (circle.v > config.distance) {
                particleArr.splice(index, 1)
            }
        }
        // window.requestAnimationFrame(drawCircle)
    }
    if (config.PEnable) {
        createCircle(pen)
        drawCircle()
    }
    // 清空数组，释放内存
    if (particleArr > MAX) {
        particleArr = []
    }
    loaded = true;
}